import * as Ord from 'fp-ts/Ord';

import { TStore, TStoreId } from './types';

export const storeIdOrd: Ord.Ord<TStoreId> = Ord.fromCompare((x, y) => (x < y ? -1 : x > y ? 1 : 0));
export const storeOrd: Ord.Ord<TStore> = Ord.fromCompare((x, y) => storeIdOrd.compare(x.id, y.id));
